import { useTranslation } from "react-i18next";
import { ColorSpinner, Flex, Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

export const LoadingContent = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Flex
      width="100%"
      flex="1"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      backgroundColor={theme.colorBackgroundSecondary}
      gap="12px"
    >
      <ColorSpinner width="50px" />
      <Text my={0} textAlign="center" fontSize="sm">
        {t("Laster innhold")}
      </Text>
    </Flex>
  );
};
